import React from 'react';

import {DUE_DATE_INFO} from 'src/modules/event-create/event-create-hovers';

import {Calendar} from '@pb/kit-component-calendar';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

type Props = {
    defaultDueDate: Date | undefined,
    onChangeDueDate: (date?: Date) => void,
};

export const DueDate = ({defaultDueDate, onChangeDueDate}: Props) => {
    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group gap="xs" alignItems="center">
                <strong>Due Date:</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {DUE_DATE_INFO}
                </Dropdown>
            </Group>
            <Calendar
                selected={defaultDueDate}
                clearableValue={defaultDueDate}
                minDate={defaultDueDate}
                onChange={onChangeDueDate}
            />
        </Group>
    );
};
